// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"panorama-horizontal"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22 4.5L22 19.5C22 19.5 17 18 12 18C7 18 2 19.5 2 19.5L2 4.5C2 4.5 7 6 12 6C17 6 22 4.5 22 4.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M22 4.5L22 19.5C22 19.5 17 18 12 18C7 18 2 19.5 2 19.5L2 4.5C2 4.5 7 6 12 6C17 6 22 4.5 22 4.5Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-panorama-horizontal')
export default class PanoramaHorizontalIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'panorama-horizontal',
    }
  }
}
